import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CobrancaJudicial } from 'src/app/base/domain/cobranca-judicial.model';

export interface PequenaCausaFormData {
  cobranca: CobrancaJudicial;
  action: string;
}

@Component({
  selector: 'app-alterar-valor-cobranca-judicial-form',
  templateUrl: './alterar-valor-cobranca-judicial-form.component.html',
  styleUrls: ['./alterar-valor-cobranca-judicial-form.component.css']
})
export class AlterarValorCobrancaJudicialFormComponent implements OnInit {

  cobrancaJudicial = new CobrancaJudicial();
  title: string;
  valor: number;

  constructor(public dialogRef: MatDialogRef<AlterarValorCobrancaJudicialFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PequenaCausaFormData) {
    this.title = 'Alterar valor da Cobrança Judicial';
    this.cobrancaJudicial = this.data.cobranca;
  }

  ngOnInit(): void {
  }

  onConfirm(): void {
    this.cobrancaJudicial.valorRestante = this.cobrancaJudicial.valor;
    this.dialogRef.close(this.cobrancaJudicial);
  }

  onCancel(): void {
    this.dialogRef.close();
  }

}
